<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs" />

      <v-card>
        <v-card-title>
          Obat
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari Obat"
            single-line
            hide-details
            @keyup.enter="getDataFromApi"
          />
          <v-spacer />

          <v-dialog v-model="dialog" persistent max-width="600px">
            <template #activator="{}">
              <v-btn color="primary" dark @click="doAdd"> Tambah </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Obat</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="currentData.nama"
                        label="Nama Obat"
                        required
                        outlined
                        dense
                        :rules="currentData.namaRules"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="currentData.kode"
                        label="Kode"
                        required
                        outlined
                        dense
                        :rules="currentData.kodeRules"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="currentData.deskripsi"
                        outlined
                        dense
                        label="Deskripsi"
                        required
                        rows="2"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedKategori"
                        label="Kategori"
                        clearable
                        dense
                        outlined
                        :items="items_category"
                        item-text="nama"
                        :rules="currentData.kategoriRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedUnit"
                        label="Satuan Unit"
                        clearable
                        dense
                        outlined
                        :items="items_unit"
                        item-text="nama"
                        :rules="currentData.unitRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedSupplier"
                        label="Supplier"
                        clearable
                        dense
                        outlined
                        :items="items_supplier"
                        item-text="nama"
                        :rules="currentData.supplierRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="currentData.harga"
                        label="Harga"
                        type="number"
                        required
                        outlined
                        dense
                        :rules="currentData.hargaRules"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="currentData.stok"
                        label="Stok"
                        type="number"
                        required
                        dense
                        outlined
                        :rules="currentData.stokRules"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn color="green" dark class="ms-2" @click="onDownloadTemplate">
            Template
          </v-btn>

          <v-btn color="blue" dark class="ms-2" @click="onUpload">
            Upload
          </v-btn>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">
                Apa anda akan menghapus data ini?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="closeDelete">
                  Tidak
                </v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                  Ya
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="isDialogUpload" persistent max-width="800px">
            <v-card>
              <VForm ref="myForm" @submit.prevent="onSubmitUpload">
                <v-card-title>
                  <span class="text-h5">Upload Data Obat</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          v-model="inputUploadFile"
                          accept=".xlsx, .xls"
                          prepend-icon="mdi-file"
                          show-size
                          label="Upload file excel"
                          :rules="uploadFileRules"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-progress-circular
                    v-if="loadingUpload"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="isDialogUpload = false"
                  >
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
                </v-card-actions>
              </VForm>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template #[`item.deskripsi`]="{ item }">
            <div>{{ ellipseText(item.deskripsi) }}</div>
          </template>

          <template #[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-icon medium class="mr-3" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

import ObatService from "../../services/master/ObatService";
import KategoriObatService from "../../services/master/KategoriObatService";
import SupplierService from "../../services/master/SupplierService";
import SatuanUnitObatService from "../../services/master/SatuanUnitObatService";
import CommonService from "../../services/CommonService";

const breadcrumbs = ref([
  {
    text: "Data Obat",
    disabled: true,
    href: "breadcrumbs_dashboard",
  },
]);

const selected = ref([]);
const childKey = ref(1);

watch(
  selected,
  (newVal) => {
    if (newVal !== undefined && newVal[0]) {
      childKey.value++;
    }
  },
  { deep: true },
);

const isDialogUpload = ref(false);
const inputUploadFile = ref(null);
const uploadFileRules = ref([(v) => !!v || "File harus diisi"]);
const myForm = ref(null);
const loadingUpload = ref(false);

const search = ref("");
const headers = ref([
  {
    text: "No",
    align: "start",
    sortable: false,
    value: "no",
  },
  { text: "Nama", value: "nama", sortable: false },
  { text: "Kode", value: "kode", sortable: false },
  { text: "Kategori", value: "nama_category", sortable: false },
  { text: "Satuan Unit", value: "nama_unit", sortable: false },
  { text: "Supplier", value: "nama_supplier", sortable: false },
  { text: "Harga", value: "harga", sortable: false },
  { text: "Stok", value: "stok", sortable: false },
  { text: "Actions", value: "actions", sortable: false },
]);
const totalData = ref(0);
const list_data = ref([]);
const loading = ref(false);
const options = ref({
  itemsPerPage: 10,
});
const editedIndex = ref(-1);
const editedItem = ref(null);

const dialog = ref(false);
const dialogDelete = ref(false);

watch(
  () => options,
  () => {
    getDataFromApi();
  },
  { deep: true },
);

const currentData = ref({
  id: null,
  nama: "",
  kode: "",
  deskripsi: "",
  selectedKategori: "",
  selectedUnit: "",
  selectedSupplier: "",
  harga: "",
  stok: "",
  namaRules: [(v) => !!v || "Nama harus diisi"],
  kategoriRules: [(v) => !!v || "Kategori harus diisi"],
  unitRules: [(v) => !!v || "Satuan Unit harus diisi"],
  supplierRules: [(v) => !!v || "Supplier harus diisi"],
  hargaRules: [(v) => !!v || "Harga harus diisi"],
  stokRules: [(v) => !!v || "Stok harus diisi"],
});

const items_category = ref([]);
const items_unit = ref([]);
const items_supplier = ref([]);

function ellipseText(text, length = 80) {
  if (!text) return "";
  return text.length > length ? text.substring(0, length) + "..." : text;
}

function getDataFromApi() {
  const { page, itemsPerPage } = options.value;

  loading.value = true;
  ObatService.obatList(page, itemsPerPage, search.value)
    .then((res) => {
      list_data.value = res.data.list_data;
      totalData.value = res.data.total;
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
      console.log(err);
    });
}

function doAdd() {
  dialog.value = true;
  currentData.value.nama = "";
  currentData.value.kode = "";
  currentData.value.deskripsi = "";
  currentData.value.selectedKategori = "";
  currentData.value.selectedUnit = "";
  currentData.value.selectedSupplier = "";
  currentData.value.harga = "";
  currentData.value.stok = "";
  currentData.value.id = null;
}

function doSave() {
  if (currentData.value.id == null) {
    ObatService.create(currentData.value)
      .then((res) => {
        console.log(res);
        dialog.value = false;

        CommonService.showSuccessToast("Tambah obat berhasil");

        getDataFromApi();
      })
      .catch((err) => {
        console.log(err);
        CommonService.showErrorToast("Tambah obat gagal. Coba lagi");
      });
  } else {
    ObatService.update(currentData.value.id, currentData.value)
      .then((res) => {
        dialog.value = false;

        console.log(res);
        CommonService.showSuccessToast("Update obat berhasil");

        getDataFromApi();
      })
      .catch((err) => {
        console.log(err);
        CommonService.showErrorToast("Update obat gagal. Coba lagi");
      });
  }
}

function editItem(item) {
  editedIndex.value = list_data.value.indexOf(item);
  editedItem.value = Object.assign({}, item);

  currentData.value.nama = "";
  currentData.value.kode = "";
  currentData.value.deskripsi = "";
  currentData.value.selectedKategori = "";
  currentData.value.selectedUnit = "";
  currentData.value.selectedSupplier = "";
  currentData.value.harga = "";
  currentData.value.stok = "";

  dialog.value = true;
  currentData.value.nama = editedItem.value.nama;
  currentData.value.kode = editedItem.value.kode;
  currentData.value.deskripsi = editedItem.value.deskripsi;
  currentData.value.harga = editedItem.value.harga;
  currentData.value.stok = editedItem.value.stok;
  currentData.value.id = editedItem.value.id;

  items_category.value.forEach((entry) => {
    if (entry.id == editedItem.value.category_id) {
      currentData.value.selectedKategori = entry;
    }
  });

  items_unit.value.forEach((entry) => {
    if (entry.id == editedItem.value.unit_id) {
      currentData.value.selectedUnit = entry;
    }
  });

  items_supplier.value.forEach((entry) => {
    if (entry.id == editedItem.value.supplier_id) {
      currentData.value.selectedSupplier = entry;
    }
  });
}

function deleteItem(item) {
  editedIndex.value = list_data.value.indexOf(item);
  editedItem.value = Object.assign({}, item);
  dialogDelete.value = true;
}

function deleteItemConfirm() {
  closeDelete();

  ObatService.delete(editedItem.value.id)
    .then((res) => {
      console.log(res);

      CommonService.showSuccessToast("Hapus obat berhasil");

      getDataFromApi();
    })
    .catch((err) => {
      console.log(err);
      CommonService.showErrorToast("Hapus obat gagal. Coba lagi");
    });
}

function closeDelete() {
  dialogDelete.value = false;
}

async function getListKategori() {
  KategoriObatService.obatListAll()
    .then((res) => {
      items_category.value = res.data.list_data;
    })
    .catch((err) => {
      console.log(err);
    });
}

async function getListUnit() {
  SatuanUnitObatService.satuanListAll()
    .then((res) => {
      items_unit.value = res.data.list_data;
    })
    .catch((err) => {
      console.log(err);
    });
}

async function getListSupplier() {
  SupplierService.supplierListAll()
    .then((res) => {
      items_supplier.value = res.data.list_data;
    })
    .catch((err) => {
      console.log(err);
    });
}

async function onDownloadTemplate() {
  window.open(
    process.env.VUE_APP_APP_URL + "/api/v1/admin/obat/template/download",
    "_blank",
  );
}

async function onUpload() {
  isDialogUpload.value = true;
  inputUploadFile.value = null;
}

function onSubmitUpload() {
  if (!myForm.value.validate()) {
    return;
  }
  console.log("upload");

  loadingUpload.value = true;

  ObatService.uploadObat(inputUploadFile.value)
    .then((res) => {
      console.log(res);

      CommonService.showSuccessToast("Upload obat berhasil");

      getDataFromApi();
      isDialogUpload.value = false;
      loadingUpload.value = false;
    })
    .catch((err) => {
      loadingUpload.value = false;
      console.log(err);
      CommonService.showErrorToast("Upload obat gagal. Coba lagi");
    });
}

onMounted(async () => {
  getDataFromApi();
  getListKategori();
  getListUnit();
  getListSupplier();
});
</script>
